var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTwoUpcoming = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 10.5,
    stroke: "#8E93A0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5874 21H20.0674V19.524H16.7314L18.3514 17.94C19.3474 16.98 20.0074 16.044 20.0074 14.904C20.0074 13.356 18.9274 12.3 17.0314 12.3C15.1114 12.3 13.9114 13.38 13.8154 15.36H15.5794C15.7114 14.232 16.1914 13.788 16.9474 13.788C17.6914 13.788 18.0874 14.244 18.0874 14.952C18.0874 15.732 17.5594 16.488 16.7314 17.364L13.5874 20.688V21Z",
    fill: "#8E93A0"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTwoUpcoming, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/two-upcoming.2bca423c.svg";
export { ForwardRef as ReactComponent };